import Roas from "@/components/brand_portfolio/Roas";
import LoadingElement from "@/components/shared/LoadingElement.vue";
export default {
  name: "BrandPortfolioRoasCell",
  components: {
    Roas,
    LoadingElement
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    portfolio: {
      type: Object,
      default: {}
    },
    periodLength: {
      type: Number,
      default: 14
    },
    period_data: {
      type: Object,
      default: {}
    },
    selected_period: {
      type: String,
      default: "weekly"
    },
    isLastSellerInWorkspace: {
      type: Boolean,
      default: false
    }
  }
};